import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { memo, useEffect, useRef, useState } from "react";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useStyle } from "../style";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import {
  onPressButton,
  setThermalData,
} from "../../../../../components/hooks/printPdf/thermalData";
import { useNavigate } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Helmet } from "react-helmet-async";

const CashClose = () => {
  const roleId = localStorage.getItem("role_id");
  const outlet_id = localStorage.getItem("outlet_id");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyle();
  const amtRef = useRef(null);
  const [salesMan, setSalesMan] = useState([]); // salesman id
  const [sideBardata, setSideBarData] = useState([]);
  const outId = localStorage.getItem("outlet_id");
  const [balance, setBalance] = useState(0);
  const [open, setOpen] = useState(false);
  const [newDayBalance, setNewDayBalance] = useState("");
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [balanceError, setBalanceError] = useState(""); // For "Amount To Be Deposited"
  const [newDayBalanceError, setNewDayBalanceError] = useState(""); // For "Next Day Balance"
  const [isFormValid, setIsFormValid] = useState(false); // Track if form is valid
  const [poDetails, setPoDetails] = useState({
    Date: moment().format(),
    salesManId: null,
  });
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().format(),
  });
  function handleChangeDate(e, name) {
    setDateLimit((prev) => ({ ...prev, [name]: dayjs(e).format() }));
  }
  const [companyData, setCompanyData] = useState([]);
  const [salesID, setSalesID] = useState(null);
  const [postData, setPostData] = useState({
    date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
    total: 0,
    outlet_id: outId,
    salesman_id: salesID === null ? null : salesID.id,
    total_invoices: "",
    total_sales: 0,
    total_card: "",
    total_cash: "",
    total_upi: "",
    total_return: "",
    total_return_used: "",
    total_loyalty: "",
    total_return_count: "",
    avg_bills: 0,
    total_less_amount: "",
    closing_cash_details: [],
  });
  console.log(sideBardata);
  const initialValue = [
    { note: 2000, nos: "", amt: "" },
    { note: 500, nos: "", amt: "" },
    { note: 200, nos: "", amt: "" },
    { note: 100, nos: "", amt: "" },
    { note: 50, nos: "", amt: "" },
    { note: 20, nos: "", amt: "" },
    { note: 10, nos: "", amt: "" },
    { note: 5, nos: "", amt: "" },
    { note: 2, nos: "", amt: "" },
    { note: 1, nos: "", amt: "" },
  ];

  const [data, setData] = useState(initialValue);
  const [active, setActive] = useState(0);

  // Validation for "Amount To Be Deposited"
  const validateBalance = (value) => {
    if (value === "") {
      setBalanceError("Amount to be deposited is required.");
      return false;
    } else {
      setBalanceError("");
      return true;
    }
  };

  // Validation for "Next Day Balance"
  const validateNextDayBalance = (value) => {
    if (value === "") {
      setNewDayBalanceError("Next Day Balance is required.");
      return false;
    } else {
      setNewDayBalanceError("");
      return true;
    }
  };

  function handleChange(e, idx) {
    const value = e.target.value.replace(/[^0-9]/g, "").trim(); // Ensures only numeric values
    const arr = [...data];

    setData([]); // Temporarily clear the data

    // Update the selected item with the new values
    arr[idx].nos = value; // nos is assigned the trimmed value
    arr[idx].amt = arr[idx].note * (value === "" ? 0 : parseFloat(value));

    console.log(value, arr[idx], arr[idx].amt);
    const isAnyDenominationFilled = arr.some((item) => item.nos !== "");

    setIsSubmitEnabled(isAnyDenominationFilled);
    // Iterate over the array to adjust amounts
    arr.forEach((item) => {
      // Convert item.nos to a string before calling trim()
      if (
        typeof item.nos === "string" &&
        !item.nos.trim() &&
        item.amt !== "0.00"
      ) {
        item.amt = "";
      }
    });

    setData(arr); // Set the updated array back into the state
  }

  function handleKey(e) {
    if (e.key === "Enter" && data.length > active) {
      setActive((prev) => prev + 1);
      amtRef.current.focus();
    }
  }
  const handleSalesMan = (e, value) => {
    setPoDetails((prev) => ({ ...prev, salesManId: value }));
    console.log(value);
    setSalesID(value);
  };
  let totalAmt = 0;

  data.forEach((item) => {
    if (item.amt !== "") {
      totalAmt += parseFloat(item.amt);
    } else {
      totalAmt += 0;
    }
  });
  const textData = {
    tot: parseFloat(totalAmt).toFixed(2),
    date: moment().format("DD-MM-YYYY"),
    totalSales: sideBardata.total_sales,
    cashSales: sideBardata.total_cash,
    cardSales: sideBardata.total_card,
    upiSales: sideBardata.total_upi,
    totalNoOfInvoice: sideBardata.total_invoices,
    totalSalesReturnAmount: sideBardata.total_return,
    SRamountUser: sideBardata.total_return_used,
    totalNoOfSalesReturn: sideBardata.total_return_count,
    averageofBills: sideBardata.total_sales / sideBardata.total_invoices || 0,
    netSales: sideBardata.total_sales,
    employee:
      poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
    totalAmount: sideBardata.total_less_amount,
  };
  const tableData = _.map(postData.closing_cash_details, (val, idx) => ({
    sno: ++idx,
    denomination: val.denomination,
    count: val.count,
    total: val.total,
  }));
  useEffect(() => {
    axios
      .get(`/v1/outlet/info/${outId}`)
      .then((res) => {
        console.log(res.data);
        setCompanyData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  // const onCheck =() => {
  //   if (poDetails.salesManId === null) {
  //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
  //   } else{
  //     setOpen(true)
  //   }
  // }
  // const onCheck = () => {
  //   // Validate balance and next day balance fields
  //   const isBalanceValid = validateBalance(balance);
  //   // const isNextDayBalanceValid = validateNextDayBalance(newDayBalance);

  //   // Check if all conditions are valid
  //   if (poDetails.salesManId === null) {
  //     dispatch(setSnackbar(true, "error", "Please Select Salesman"));
  //   } else if (!isBalanceValid) {
  //     // If balance or next day balance is invalid, don't proceed and let the validation errors show
  //     setIsFormValid(false);
  //   } else {
  //     // If all conditions are valid, open the modal
  //     setIsFormValid(true);
  //     setOpen(true);
  //     console.log("Form is valid and the modal is open!");
  //   }
  // };
  const onCheck = () => {
    if (poDetails.salesManId === null) {
      dispatch(setSnackbar(true, "error", "Please Select Salesman"));
      return;
    }
    if (
      Math.round(parseFloat(totalAmt)) !==
      Math.round(parseFloat(sideBardata.total_cash || 0))
    ) {
      dispatch(
        setSnackbar(
          true,
          "error",
          `Denomination total ₹${parseFloat(totalAmt).toFixed(2)} does not match Total Cash ₹${parseFloat(sideBardata.total_cash || 0).toFixed(2)}`,
        ),
      );
      return;
    }

    setOpen(true); // unchanged
  };
  console.log(postData);
  const onSave = () => {
    // if (poDetails.salesManId === null) {
    //   dispatch(setSnackbar(true, "error", "Please Select Salesman"));
    // }
    // // else if(balance === "") {
    // //   dispatch(setSnackbar(true, "error", "Please Enter The Deposited Amount"));
    // // }
    // else {
    console.log("post method", postData);
    axios
      .post(`/v1/closing_cash_master`, postData)
      .then((res) => {
        console.log(res);
        setData(initialValue);
        setOpen(false);
        // dispatch(setSnackbar(true, 'success', "Cash Closed successfully"))
        // setTimeout(() => {
        //   window.location.reload();
        // },[1000])

        dispatch(
          setThermalData({
            tableData: tableData,
            TotalData: textData,
            companyInfo: companyData,
          }),
        );
        dispatch(onPressButton());
        const name = `CashBill`;
        navigate(`/cashClose/${name}`);
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
        setOpen(false);
      });
  };
  function getSalesMan() {
    axios
      .get(`v1/SalesMan/outlets/${outlet_id}`)
      .then((res) => setSalesMan(res.data))
      .catch((err) => console.log(err));
  }
  const onBalanceChange = (e) => {
    console.log("Event fired:", e); // Log the event to see if it's being triggered
    const inputValue = e.target.value.replace(/[^0-9]/g, "");

    console.log(data, "inputValue"); // This should log the sanitized input value
    setBalance(inputValue);
    // validateBalance(inputValue);
    if (inputValue === "") {
      setNewDayBalance("");
    } else if (totalAmt > inputValue) {
      setNewDayBalance(totalAmt - inputValue);
    } else {
      setNewDayBalance(inputValue - totalAmt);
    }
  };

  const newBalanceChange = (e) => {
    const newB = e.target.value.replace(/[^0-9]/g, "");
    setNewDayBalance(newB);
    // validateNextDayBalance(newB);
  };
  useEffect(() => {
    getSalesMan();
    // Fetch the sales overview including denomination details
    axios
      .get(
        `/v1/reports/salesoverview/${outId}/${moment(dateLimit.fromDate).format("YYYY-MM-DD")}`,
      )
      .then((res) => {
        console.log(res.data, "API response");
        setSideBarData(res.data);

        // Check if API response contains expected data
        if (res.data && res.data.dinominationDetails) {
          const closingLines = res.data.dinominationDetails || [];
          console.log(closingLines, "Denomination details");
          const amountBeDeposited =
            closingLines.length > 0 ? closingLines[0].amount_be_deposited : 0;
          setBalance(amountBeDeposited);
          const amountNextbalance =
            closingLines.length > 0 ? closingLines[0].next_day_balance : 0;
          setNewDayBalance(amountNextbalance);
          const closingCashLines =
            closingLines.length > 0 ? closingLines[0].closing_cash_lines : [];
          console.log(amountNextbalance, "Closing cash lines");

          // If closing cash lines are found, update the values, otherwise fallback to default
          if (closingCashLines.length > 0) {
            updateInitialValue(closingCashLines);
          } else {
            console.log("No closing cash lines found. Using default values.");
            setDefaultDenominationValues(); // Use default values if the API response is empty
          }
        } else {
          console.log(
            "No denomination details in the response. Using default values.",
          );
          setDefaultDenominationValues(); // Fallback to default values if data is missing
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
        setSideBarData([]);
        setDefaultDenominationValues(); // Fallback to default values in case of error
      });
  }, [dateLimit]);

  // Function to update the denomination values from API
  const updateInitialValue = (closingCashLines) => {
    const updatedValues = initialValue.map((denom) => {
      const line = closingCashLines.find(
        (line) => line.denomination === denom.note,
      );
      if (line) {
        return {
          ...denom,
          nos: line.count, // Use the count from closing lines
          amt: (line.denomination * line.count).toFixed(2), // Calculate the total amount
        };
      } else {
        return denom; // Return default values if not found
      }
    });

    setData(updatedValues); // Update state with new values
  };

  // Function to set default denomination values if API response is empty
  const setDefaultDenominationValues = () => {
    const defaultValues = initialValue.map((denom) => ({
      ...denom,
      nos: 0, // Default count
      amt: (denom.note * 0).toFixed(2), // Default amount set to 0
    }));

    console.log(defaultValues, "Default denomination values");
    setData(defaultValues); // Set default values to the state
  };

  useEffect(() => {
    if (salesID) {
      setPostData((prev) => ({
        ...prev,
        salesman_id: salesID.id,
        date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      }));
    }
  }, [salesID, dateLimit]);
  useEffect(() => {
    const postingData = data
      .filter((item) => item.nos !== "" && item.amt !== "")
      .map((item) => ({
        denomination: item.note,
        count: parseInt(item.nos),
        total: parseFloat(item.amt),
        date: moment().format("YYYY-MM-DD"),
        outlet_id: outId,
        salesman_id: salesID === null ? null : salesID.id,
      }));

    console.log(postingData, "postingDatapostingData");
    if (postingData.length == 0) {
      setBalance(0);
      setNewDayBalance("0");
    }
    setPostData((prev) => ({
      ...prev,
      date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      closing_cash_details: postingData,
      total: parseFloat(totalAmt).toFixed(2),
      total_invoices: sideBardata.total_invoices,
      total_sales: sideBardata.total_sales,
      total_card: sideBardata.total_card,
      total_cash: sideBardata.total_cash,
      total_upi: sideBardata.total_upi,
      total_return: sideBardata.total_return,
      total_return_used: sideBardata.total_return_used,
      total_loyalty: sideBardata.total_loyalty,
      total_return_count: sideBardata.total_return_count,
      total_less_amount: sideBardata.total_less_amount,
      // avg_bills:parseFloat(sideBardata.total_sales / sideBardata.total_invoices).toFixed(2) || 0,
      avg_bills: sideBardata.total_invoices
        ? parseFloat(
            (sideBardata.total_sales / sideBardata.total_invoices).toFixed(2),
          )
        : 0,

      amount_be_deposited: balance,
      next_day_balance: newDayBalance,
    }));
  }, [data, salesID, sideBardata, balance, newDayBalance, dateLimit]);

  console.log(postData, "postdata");
  console.log(balance, "balance");
  console.log(
    sideBardata,
    "sideBardata",
    parseFloat(sideBardata.total_sales).toFixed(2),
  );
  console.log(
    poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
  );
  return (
    <Grid className="bg-white relative ">
      <Grid
        className="flex justify-between items-center px-2"
        sx={{ marginBlockEnd: 1 }}
      >
        <Helmet>
          <title>Cash Close</title>
        </Helmet>
        <div>
          <Typography className={classes.titleCashClose}>Cash Close</Typography>
        </div>
        <Grid className="flex-1">
          <Autocomplete
            id="salesman"
            name="salesman"
            size="small"
            options={salesMan}
            getOptionLabel={(option) =>
              `${option.sales_man_name} - ${option.sales_man_code}`
            }
            value={poDetails.salesManId}
            onChange={handleSalesMan}
            disableClearable
            isOptionEqualToValue={(option, value) => option.id === value.id}
            sx={{ marginBlock: 1, width: "250px", marginInline: 1 }}
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Salesman" autoComplete="off" />
            )}
          />
        </Grid>
        <div className="flex items-center">
          {/* <Typography>Date</Typography>
          <TextField
            size="small"
            sx={{ marginInline: 2 }}
            value={moment().format("DD-MM-YYYY")}
          /> */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChangeDate(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2}
              slotProps={{
                textField: {
                  size: "small",
                  label: "From",
                  style: { width: "100%" },
                },
              }}
            />
          </LocalizationProvider>
        </div>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={6} md={8}>
          <TableContainer
            className={classes.tblRoot}
            sx={{ maxWidth: "70%", margin: "0 auto" }}
          >
            <Table>
              <TableHead className={classes.tblHeader}>
                <TableRow>
                  <TableCell
                    sx={{
                      borderRight: "0.5px solid  #ccc",
                      textAlign: "center",
                    }}
                  >
                    Notes
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "0.5px solid  #ccc",
                      textAlign: "center",
                    }}
                  >
                    Nos
                  </TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.map(data, (val, idx) => (
                  <TableRow
                    key={val.note}
                    className={classes.tablrow}
                    onClick={() => setActive(idx)}
                  >
                    <TableCell
                      sx={{ borderRight: `1px solid #ccc` }}
                      className={classes.tblHeadCell}
                    >
                      {val.note}
                    </TableCell>
                    <TableCell sx={{ borderRight: `1px solid #ccc` }}>
                      <TextField
                        size="small"
                        autoComplete="off"
                        value={val.nos}
                        onKeyPress={(e) => handleKey(e, idx)}
                        inputRef={active === idx ? amtRef : null}
                        InputProps={{
                          style: {
                            maxHeight: "10px",
                            outline: "none",
                            fontSize: 14,
                          },
                        }}
                        inputProps={{ style: { textAlign: "right" } }}
                        className={classes.tableInput}
                        onChange={(e) => handleChange(e, idx)}
                      />
                    </TableCell>

                    <TableCell
                      align="right"
                      padding="checkbox"
                      sx={{
                        minWidth: 130,
                        fontWeight: 700,
                        padding: 0,
                        height: "25px",
                      }}
                    >
                      <Typography fontWeight={700} textAlign="right">
                        {val.amt !== "" && parseFloat(val.amt).toFixed(2)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow className={classes.tablrow} sx={{ padding: 0 }}>
                  <TableCell sx={{ borderRight: `1px solid #ccc` }} />
                  <TableCell />
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ padding: "7px", height: "15px" }}
                    colSpan={2}
                  >
                    Total
                  </TableCell>
                  <TableCell
                    sx={{
                      borderLeft: `1px solid #ccc`,
                      textAlign: "right",
                      fontWeight: 700,
                      padding: "7px",
                      height: "15px",
                    }}
                  >
                    {parseFloat(totalAmt).toFixed(2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ padding: "7px", height: "15px" }}
                  >
                    Amount To Be Deposited
                  </TableCell>
                  <TableCell
                    sx={{
                      borderLeft: `1px solid #ccc`,
                      textAlign: "right",
                      fontWeight: 700,
                      padding: "7px",
                      height: "15px",
                    }}
                  >
                    <TextField
                      size="small"
                      autoComplete="off"
                      disabled={totalAmt === 0}
                      inputProps={{
                        style: {
                          textAlign: "right",
                          fontWeight: "bold",
                          padding: "7px",
                          height: "15px",
                        },
                      }}
                      value={balance}
                      onChange={onBalanceChange}
                      error={!!balanceError}
                      helperText={balanceError}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ padding: "7px", height: "15px" }}
                    colSpan={2}
                  >
                    Next Day Balance
                  </TableCell>
                  <TableCell
                    sx={{
                      borderLeft: `1px solid #ccc`,
                      textAlign: "right",
                      fontWeight: 700,
                      padding: "7px",
                      height: "15px",
                    }}
                  >
                    <TextField
                      size="small"
                      autoComplete="off"
                      inputProps={{
                        style: {
                          textAlign: "right",
                          fontWeight: "bold",
                          padding: "7px",
                          height: "15px",
                        },
                      }}
                      disabled={balance === ""}
                      value={newDayBalance}
                      onChange={newBalanceChange}
                      // error={!!newDayBalanceError}
                      // helperText={newDayBalanceError}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* <Grid className="my-2 flex justify-center">
            <Button  onClick={onCheck} 
            disabled={sideBardata}
             sx={{backgroundColor: sideBardata ? "grey" :"#A06EE1",color:"#fff !important",'&:hover': {
      backgroundColor: sideBardata ? 'darkgrey' : '#A06EE1', }}}
      
      >
              Submit
            </Button>
          </Grid> */}
          <Grid className="my-2 flex justify-center">
            <Button
              onClick={onCheck}
              variant="contained"
              // disabled={ !isSubmitEnabled || sideBardata.length === 0 || !isSubmitEnabled}
              //        sx={{backgroundColor: sideBardata.length === 0 || !isSubmitEnabled ? "grey" :"#A06EE1",color:"#fff !important",'&:hover': {
              // backgroundColor: sideBardata.length === 0 || !isSubmitEnabled ? 'darkgrey' : '#A06EE1', }}}
            >
              Submit
            </Button>
            {/* <Button  onClick={onCheck} disabled={ !isSubmitEnabled || sideBardata.length === 0 || !isSubmitEnabled} sx={{backgroundColor: sideBardata.length === 0 || !isSubmitEnabled ? "grey" :"#A06EE1",color:"#fff !important",'&:hover': {
      backgroundColor: sideBardata.length === 0 || !isSubmitEnabled ? 'darkgrey' : '#A06EE1', }}} >
              Submit
            </Button> */}
          </Grid>
          {/* <Grid className="my-2 flex justify-center">
            <Button  onClick={onCheck} disabled={sideBardata.length === 0} sx={{backgroundColor: sideBardata.length === 0 ? "grey" :"#A06EE1",color:"#fff !important",'&:hover': {
      backgroundColor: sideBardata.length === 0 ? 'darkgrey' : '#A06EE1', }}}>
              Submit
            </Button>
          </Grid> */}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <div
            style={{
              paddingInline: 5,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
            }}
          >
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Sales</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#B284BE", color: "#fff" }}
                value={
                  sideBardata.total_sales
                    ? Math.round(sideBardata.total_sales).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Invoices</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#9966CC", color: "#fff !important" }}
                value={
                  sideBardata.total_invoices
                    ? parseFloat(sideBardata.total_invoices).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Card</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                sx={{ backgroundColor: "#B57EDC" }}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                value={
                  sideBardata.total_card
                    ? parseFloat(sideBardata.total_card).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Cash</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#000",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#ccc" }}
                value={
                  sideBardata.total_cash
                    ? parseFloat(sideBardata.total_cash).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Upi</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#000",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#E0B0FF" }}
                value={
                  sideBardata.total_upi
                    ? parseFloat(sideBardata.total_upi).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Return</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#DA70D6" }}
                value={
                  sideBardata.total_return
                    ? parseFloat(sideBardata.total_return).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Return Used</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#000",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#FAE6FA" }}
                value={
                  sideBardata.total_return_used
                    ? parseFloat(sideBardata.total_return_used).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Loyalty</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#9400D3" }}
                value={
                  sideBardata.total_loyalty
                    ? Math.round(sideBardata.total_loyalty).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Less Amount</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  },
                }}
                sx={{ backgroundColor: "#9400D3" }}
                value={
                  sideBardata.total_less_amount
                    ? parseFloat(sideBardata.total_less_amount).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Return Count</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#000",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#DDA0DD" }}
                value={
                  sideBardata.total_return_count
                    ? parseFloat(sideBardata.total_return_count).toFixed(2)
                    : 0
                }
              />
            </Grid>
            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Total Discount Amount</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#000",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#DDA0DD" }}
                value={
                  sideBardata.total_discount_amount
                    ? parseFloat(sideBardata.total_discount_amount).toFixed(2)
                    : 0
                }
              />
            </Grid>

            <Grid className={classes.flexCorrection}>
              <Typography fontWeight={600}>Avg Sales</Typography>
              <TextField
                size="small"
                className={classes.TextFieldCash}
                inputProps={{
                  style: {
                    color: "#fff",
                    textAlign: "right",
                    fontWeight: "bold",
                  }, // Set text color to white
                }}
                sx={{ backgroundColor: "#000", textAlign: "right" }}
                value={Math.round(
                  sideBardata.total_sales / sideBardata.total_invoices || 0,
                ).toFixed(2)}
              />
            </Grid>
          </div>
        </Grid>
      </Grid>
      <Dialog open={open}>
        <DialogTitle>Cash CLose</DialogTitle>
        <DialogContent>
          <Typography>Are you sure want to close the cash</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            No
          </Button>
          <Button variant="contained" onClick={onSave}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default memo(CashClose);
